export default "__VITE_ASSET__81aa7854__"